import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { getTradersByID } from '../../api/traders';

const ModalOrderList = ({ show, handleClose, event }) => {
  const [traderData, setTraderData] = useState(event ? { ...event, farmerId: event.farmer_id } : {});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (event && event.farmer_id) {
      setLoading(true);
      getTradersByID(event.farmer_id, (result) => {
        setLoading(false);
        if (result.ok !== 1) {
          return console.log(result);
        }
        setTraderData(result.result);
      });
    }
  }, [event]);

  if (!event) return null;

  const handleCompleteOrder = () => {
    console.log('Complete order:', event);
    alert('Order completion functionality will be implemented with backend integration');
  };

  const handleCancelOrder = () => {
    if (window.confirm('Are you sure you want to cancel this order?')) {
      console.log('Cancel order:', event);
      alert('Order cancellation functionality will be implemented with backend integration');
    }
  };

  const getStatusBadge = (status) => {
    switch (status?.toLowerCase()) {
      case 'pending':
        return <span className="badge bg-warning text-dark">Pending</span>;
      case 'approved':
        return <span className="badge bg-success">Approved</span>;
      case 'cancelled':
        return <span className="badge bg-danger">Cancelled</span>;
      default:
        return <span className="badge bg-secondary">Unknown</span>;
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered backdrop="static">
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="fw-bold text-dark">
          <i className="bi bi-cart-check me-2 text-primary"></i>
          Order Details
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        <div className="mb-4">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="fw-bold text-primary mb-0">
              Order #{event.orderID || "N/A"}
            </h5>
            {getStatusBadge(event.status)}
          </div>
          <p className="text-muted mb-0">
            <i className="bi bi-calendar3 me-2"></i>
            {event.date_time || "No date available"}
          </p>
        </div>

        {/* Order Parties */}
        <div className="card border-0 shadow-sm mb-4">
          <div className="card-header bg-light border-0">
            <h6 className="mb-0 fw-semibold">
              <i className="bi bi-people me-2"></i>
              Order Parties
            </h6>
          </div>
          <div className="card-body">
            <div className="row g-4">
              <div className="col-md-6">
                <div className="border-start border-primary border-3 ps-3">
                  <h6 className="fw-bold text-primary mb-2">
                    <i className="bi bi-person-circle me-2"></i>
                    Customer
                  </h6>
                  <div className="mb-2">
                    <strong>Name:</strong> {event.user_name || "N/A"}
                  </div>
                  <div className="mb-2">
                    <strong>Location:</strong> {event.location || "N/A"}
                  </div>
                  <div>
                    <strong>Contact ID:</strong> {event.user_id || "N/A"}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="border-start border-success border-3 ps-3">
                  <h6 className="fw-bold text-success mb-2">
                    <i className="bi bi-shop me-2"></i>
                    Trader
                  </h6>
                  <div className="mb-2">
                    <strong>Name:</strong> {event.farmer_name || "N/A"}
                  </div>
                  <div className="mb-2">
                    <strong>Location:</strong> {traderData.address || "Holili"}
                  </div>
                  <div>
                    <strong>Status:</strong> 
                    <span className="badge bg-success bg-opacity-10 text-success ms-2">
                      Active Trader
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Order Items */}
        <div className="card border-0 shadow-sm mb-4">
          <div className="card-header bg-light border-0">
            <h6 className="mb-0 fw-semibold">
              <i className="bi bi-box-seam me-2"></i>
              Order Items
            </h6>
          </div>
          <div className="card-body p-0">
            <div className="table-responsive">
              <table className="table table-hover mb-0">
                <thead className="table-light">
                  <tr>
                    <th className="fw-semibold border-0">Product</th>
                    <th className="fw-semibold border-0 text-center">Quantity</th>
                    <th className="fw-semibold border-0 text-end">Unit Price</th>
                    <th className="fw-semibold border-0 text-end">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="align-middle">
                      <div className="d-flex align-items-center">
                        <div className="bg-primary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3" style={{width: '40px', height: '40px'}}>
                          <i className="bi bi-box text-primary"></i>
                        </div>
                        <div>
                          <div className="fw-semibold">{event.product_name || "N/A"}</div>
                          <small className="text-muted">Per {event.unit || "unit"}</small>
                        </div>
                      </div>
                    </td>
                    <td className="text-center align-middle">
                      <span className="badge bg-info bg-opacity-10 text-info fs-6">
                        {event.quantity || "N/A"} {event.unit || ""}
                      </span>
                    </td>
                    <td className="text-end align-middle">
                      <span className="fw-medium">
                        {event.currency_name || "N/A"} {event.unit_price || "N/A"}
                      </span>
                    </td>
                    <td className="text-end align-middle">
                      <span className="fw-bold text-success fs-5">
                        {event.currency_name || "N/A"} {event.total_price || "N/A"}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Order Summary */}
        <div className="card border-0 shadow-sm mb-4">
          <div className="card-body">
            <div className="row justify-content-end">
              <div className="col-md-6">
                <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                  <span className="text-muted">Subtotal:</span>
                  <span className="fw-medium">
                    {event.currency_name || "N/A"} {event.total_price || "N/A"}
                  </span>
                </div>
                <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                  <span className="text-muted">Tax:</span>
                  <span className="fw-medium">N/A</span>
                </div>
                <div className="d-flex justify-content-between align-items-center py-3">
                  <span className="fw-bold fs-5">Total Amount:</span>
                  <span className="fw-bold fs-4 text-success">
                    {event.currency_name || "N/A"} {event.total_price || "N/A"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="d-flex flex-column flex-sm-row justify-content-end gap-3">
          <button 
            className="btn btn-secondary px-4"
            onClick={handleClose}
            style={{ borderRadius: '8px' }}
          >
            <i className="bi bi-x-circle me-2"></i>
            Close
          </button>
          {event.status?.toLowerCase() === 'pending' && (
            <>
              <button 
                className="btn btn-danger px-4"
                onClick={handleCancelOrder}
                style={{ borderRadius: '8px' }}
              >
                <i className="bi bi-x-octagon me-2"></i>
                Cancel Order
              </button>
              <button 
                className="btn btn-success px-4"
                onClick={handleCompleteOrder}
                style={{ borderRadius: '8px' }}
              >
                <i className="bi bi-check-circle me-2"></i>
                Complete Order
              </button>
            </>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalOrderList;